import { getLocalStorage } from '@theme/utilities';

const STORAGE_PREFIX = 'hds:announcement-bar-dismissed:';

/**
 * @param {string} sectionId
 * @returns {string}
 */
function getStorageKey(sectionId) {
  return `${STORAGE_PREFIX}${sectionId}`;
}

/**
 * @param {string} sectionId
 */
function hideSection(sectionId) {
  const section = document.getElementById(`shopify-section-${sectionId}`);
  if (section instanceof HTMLElement) {
    section.hidden = true;
    document.dispatchEvent(new CustomEvent('announcement-bar-stack:updated'));
  }
}

/**
 * @param {string} sectionId
 * @param {Storage | null} storage
 * @returns {boolean}
 */
function isDismissed(sectionId, storage) {
  return storage?.getItem(getStorageKey(sectionId)) === '1';
}

/**
 * @param {string} sectionId
 * @param {Storage | null} storage
 */
function dismiss(sectionId, storage) {
  try {
    storage?.setItem(getStorageKey(sectionId), '1');
  } catch {
    // localStorage may be full or blocked
  }

  hideSection(sectionId);
}

/**
 * @param {Element} element
 * @returns {string | undefined}
 */
function getSectionIdFromElement(element) {
  const section = element.closest('[id^="shopify-section-"]');
  if (!section?.id) return undefined;

  return section.id.replace(/^shopify-section-/, '');
}

function init() {
  const storage = getLocalStorage();
  const isDesignMode = Boolean(window.Shopify?.designMode);

  document.querySelectorAll('[data-announcement-dismiss]').forEach((button) => {
    if (!(button instanceof HTMLButtonElement)) return;

    const sectionId = button.dataset.sectionId || getSectionIdFromElement(button);
    if (!sectionId) return;

    const section = document.getElementById(`shopify-section-${sectionId}`);
    if (!(section instanceof HTMLElement)) return;

    if (isDesignMode) {
      section.hidden = false;
      return;
    }

    if (isDismissed(sectionId, storage)) {
      hideSection(sectionId);
    }

    button.addEventListener('click', () => {
      dismiss(sectionId, storage);
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
